import { render, staticRenderFns } from "./BlogPost.vue?vue&type=template&id=920e5848"
import script from "./BlogPost.vue?vue&type=script&lang=js"
export * from "./BlogPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default,ComponentLoader: require('/vercel/path0/components/ComponentLoader.vue').default,SuggestedBlogPosts: require('/vercel/path0/components/shared/SuggestedBlogPosts.vue').default})
